import { SimpleGrid as ChakraSimpleGrid, SimpleGridProps as ChakraSimpleGridProps } from '@chakra-ui/react';

const SimpleGrid = ({ children, ...props }: ChakraSimpleGridProps) => (
  <ChakraSimpleGrid {...props}>{children}</ChakraSimpleGrid>
);

export { SimpleGrid };
